import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function WorkerNotification() {
    
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [workerList, setWorkerList] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        worker: "",
        title: "",
        message: "",
        is_read: false
    });
    useEffect(() => {
        getNotifications();
        getWorkers();
    }, []);
    const getNotifications = () => {
        setLoading(true);
        axios.get(baseUrl + "workernotification/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const getWorkers = () => {
        axios.get(baseUrl + "workerprofile/")
            .then((res) => {
                setWorkerList(res.data);
            });
    };
    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            worker: "",
            title: "",
            message: "",
            is_read: false
        });
    };
    const saveData = (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("worker", formData.worker);
        data.append("title", formData.title);
        data.append("message", formData.message);
        data.append("is_read", formData.is_read);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        if (editId === null) {
            axios.post(baseUrl + "workernotification/", data)
                .then(() => {
                    Swal.fire("Success", "Notification Saved", "success");
                    clearForm();
                    getNotifications();
                });
        } else {
            axios.put(baseUrl + `update-workernotification/${editId}/`, data)
                .then(() => {
                    Swal.fire("Updated", "Notification Updated", "success");
                    clearForm();
                    getNotifications();
                });
        }
    };
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            worker: row.worker,
            title: row.title,
            message: row.message,
            is_read: row.is_read
        });
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete?",
            icon: "warning",
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`update-workernotification/${id}/`)
                    .then(() => {
                        Swal.fire("Deleted", "", "success");
                        getNotifications();
                    });
            }
        });
    };
    const columns = [
        {
            field: "id", headerName: "ID", width: 70
        },
        {
            field: "worker",
            headerName: "Worker",
            width: 220,
            valueGetter: (params) => params.row.worker ? `${params.row.worker.first_name} ${params.row.worker.last_name}` : ""
        },
        {
            field: "title", headerName: "Title", width: 220
        },
        {
            field: "message", headerName: "Message", width: 350
        },
        {
            field: "is_read", headerName: "Read", width: 100
        },
        {
            field: "action", headerName: "Action", width: 180,
            renderCell: (params) => (
                <>

                    <button
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => editData(params.row)}
                    >
                        Edit
                    </button>

                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteData(params.row.id)}
                    >
                        Delete
                    </button>

                </>
            )
        }
    ];
    return (
        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-success text-white">

                    <h5 className="mb-0">

                        Worker Notification

                    </h5>

                </div>

                <div className="card-body">

                    <form onSubmit={saveData}>

                        <div className="row">
                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Worker
                                </label>

                                <select
                                    className="form-control"
                                    name="worker"
                                    value={formData.worker}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Worker
                                    </option>

                                    {workerList.map((item) => (
                                        <option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.first_name} {item.last_name}
                                        </option>
                                    ))}

                                </select>

                            </div>

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Read Status
                                </label>

                                <select
                                    className="form-control"
                                    name="is_read"
                                    value={formData.is_read}
                                    onChange={handleChange}
                                >

                                    <option value={false}>
                                        Unread
                                    </option>

                                    <option value={true}>
                                        Read
                                    </option>

                                </select>

                            </div>

                            <div className="col-md-12 mb-3">

                                <label className="form-label">
                                    Title
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-12 mb-3">

                                <label className="form-label">
                                    Message
                                </label>

                                <textarea
                                    className="form-control"
                                    rows="5"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-12">

                                <button
                                    type="submit"
                                    className="btn btn-success me-2"
                                >
                                    {editId === null ? "Save" : "Update"}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={clearForm}
                                >
                                    Clear
                                </button>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

            <div className="card shadow mt-3">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Worker Notification List
                    </h5>

                </div>

                <div className="card-body">

                    <div style={{height: 550, width: "100%"}}>

                        <ERPDataGrid
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            getRowId={(row) => row.id}
                            pageSizeOptions={[10, 25, 50, 100]}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            }}

                        />

                    </div>

                </div>

            </div>
        </div>
    );
}
export default WorkerNotification;